'use client'

import React from 'react'
import { usePathname } from 'next/navigation'
import Link from 'next/link'
import { useTranslation } from 'react-i18next'

const NewsMaterialsTitle = () => {
    const { t } = useTranslation()
    const pathnameNews = usePathname().includes('/news')

    return (
        <div className='news__title-links'>
            <h1>
                <Link
                    style={{ display: 'inline-block' }}
                    className={pathnameNews ? 'news__title-link news__title-link_selected' : 'news__title-link'}
                    href={`/news`}
                >
                    {t('news')}
                </Link>
            </h1>
            <h2>
                <Link
                    style={{ display: 'inline-block' }}
                    className={pathnameNews ? 'news__title-link' : 'news__title-link news__title-link_selected'}
                    href={`/useful-materials`}
                >
                    {t('usefulMaterialsTitle')}
                </Link>
            </h2>
        </div>
    )
}

export default NewsMaterialsTitle
